import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Big } from 'foundations-components/transitional/components/Big';
import { jsx as _jsx } from "react/jsx-runtime";
const GenericPopoverErrorState = () => /*#__PURE__*/_jsx(TFlex, {
  direction: "column",
  align: "center",
  padding: "1000",
  children: /*#__PURE__*/_jsx(Big, {
    textAlign: "center",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "draftPlugins.knowledgeArticlesPlugin.fetchError"
    })
  })
});
export default GenericPopoverErrorState;